<template>
  <div v-if="errors && Object.keys(errors).length">
    <v-alert
        dense
        color="error"
        outlined
        type="warning"
    >
    {{warningLabel}}:
    <v-list dense>
      <v-list-item v-for="(error, index) in errors" :key="index">
        <v-list-item-content>
          <v-list-item-title>{{error}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    </v-alert>
  </div>
  <div v-else>
    <v-alert
        dense
        text
        type="success">
    We have scanned your report and found no warnings.
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "ReportErrors.vue",
  props: {
    errors: Object,
    warningLabel: {
      type: String,
      default: "Warning"
    }
  },
}
</script>

